/**
 * @flow
 */

// JSON.parse result is returned directly as a number by decodeInt/decodeFloat without narrowing.
// $FlowFixMe[unclear-type]
const decodeJSON = (encodedJSON: string): any => JSON.parse(atob(encodedJSON));

// Returns parsed JSON that callers narrow to their own varied shapes.
// $FlowFixMe[unclear-type]
export const decodeObject = (json: string): any => {
  return decodeJSON(json);
};

export const decodeString = (json: string): string => {
  const decoded: unknown = decodeJSON(json);
  if (typeof decoded !== "string") {
    throw new TypeError(`Expected type 'string', got ${typeof decoded}. Decoded: ${String(decoded)} from ${json}.`);
  }
  return decoded;
};

export const decodeInt = (json: string): number => {
  const decoded = decodeJSON(json);
  if (Number.isNaN(decoded)) {
    throw new TypeError(`Expected a value that could be parsed as an integer, got ${decoded} from ${json}.`);
  }
  return decoded;
};

export const decodeFloat = (json: string): number => {
  const decoded = decodeJSON(json);
  if (Number.isNaN(decoded)) {
    throw new TypeError(`Expected a value that could be parsed as a float, got ${decoded} from ${json}.`);
  }
  return decoded;
};

/**
 * We're expecting either a JSON boolean or exactly the string "true" or "false".
 * @param json
 * @returns {boolean}
 */
export const decodeBoolean = (json: string): boolean => {
  const decoded: unknown = decodeJSON(json);
  if (typeof decoded !== "boolean") {
    throw new TypeError(`Expected type 'boolean', got ${typeof decoded}. Decoded: ${String(decoded)} from ${json}.`);
  }
  return decoded;
};

export const decodeMap = (json: string): Map<string, unknown> => {
  return new Map(Object.entries(decodeObject(json)));
};

export function objectToNumberStringMap(object: { readonly [string]: unknown }): Map<number, string> {
  return new Map(Object.entries(object).map(([key, value]) => [Number(key), String(value)]));
}
